module.exports = __webpack_public_path__ + "static/frontUserNew/media/send_order.2f787e03.wav";